<template>
  <v-container class="max-container">
      <!--WARNING-BOX-->
        <v-row class="warningbox__row">
            <v-col cols="12" class="warningbox__row__col no-pd">
                <v-skeleton-loader class="warningbox__row__col__type" type="image"/>               
            </v-col>
        </v-row>
      <!--END-WARNING-BOX-->
      <!--ADDRESS-and-MAP-->
        <v-row class="addressandmap__row">
            <v-col :cols=" colResponsive ? '12' : '4' " class="addressandmap__row__col__info">
                <v-row class="addressandmap__row__col__info__row">
                    <v-col class="addressandmap__row__col__info__row__col no-pd-l" :cols=" colResponsive ? '5' :  '7' ">
                        <v-skeleton-loader class="addressandmap__row__col__info__row__col__title" type="image" />
                    </v-col>
                    <v-col class="addressandmap__row__col__info__row__col__1" :cols=" colResponsive ? '4' : '5' ">
                        <v-skeleton-loader class="addressandmap__row__col__info__row__col__subtitle" type="image"/>
                    </v-col>
                    <v-col class="addressandmap__row__col__info__row__col__2" cols="12">
                        <v-row class="addressandmap__row__col__info__row__col__row" v-for="n in 3" :key="n">
                            <v-col cols="1">
                                <v-skeleton-loader class="addressandmap__row__col__info__row__col__row__col__avatar" type="image"/>
                            </v-col>
                            <v-col :cols=" colResponsive ? '7' : '10' ">
                                <v-skeleton-loader class="addressandmap__row__col__info__row__col__row__col__text" type="text"/>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
            <v-col :cols=" colResponsive ? '12' : '8' " class="addressandmap__row__col__map no-pd-l no-pd-r">
                <v-row class="addressandmap__row__col__map__row">
                    <v-col class="addressandmap__row__col__map__row__col" cols="12">
                        <v-skeleton-loader class="addressandmap__row__col__map__row__col__map" type="image"/>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
      <!--END-ADDRESS-and-MAP-->
  </v-container>
</template>

<script>
export default {
    name: 'shopAdrressLoader',
    data: () => ({
        colResponsive: false
    }),
    created() {
        this.compareWidth()
        window.addEventListener("resize", this.compareWidth);
    },
    methods: {
        compareWidth() {
            ( window.innerWidth < 960)? this.colResponsive = true : this.colResponsive = false;

        },
    }

}
</script>

<style scoped>
/*WARNING-BOX*/
    .warningbox__row {
        margin-top: 4px;
    }
    .warningbox__row__col__type {
        max-width: 1160px;
        height: 90px;
        border-radius: 14px !important;
    }
    
/*END-WARNING-BOX*/

/*ADDRESS-and-MAP*/
    /*INFO-ADDRESS*/
        .addressandmap__row {
            margin-top: 16px;
        }
        .addressandmap__row__col__info__row {
            display: flex;
            flex: auto !important;
            flex-direction: column;
        }
        .addressandmap__row__col__info__row__col__title {
            height: 24px;
            border-radius: 10px;
            min-width: 199px;
        }
        .addressandmap__row__col__info__row__col__subtitle {
            height: 18px;
            border-radius: 8px;
            margin-top: 24px;
            min-width: 126px;
        }
        .addressandmap__row__col__info__row__col__row {
            display: flex;
            flex: auto !important;
            flex-direction: row;
        }
        .addressandmap__row__col__info__row__col__row__col__avatar {
            width: 22px;
            height: 22px;
            border-radius: 16px;
        }
    /*END-INFO-ADDRESS*/
    /*MAP-ADDRESS*/
        .addressandmap__row__col__map__row__col__map {
            height: 306px !important;
        }
    /*END-MAP-ADDRESS*/
/*END-ADDRESS-and-MAP*/
/*#########RESPONSIVE#############*/
    @media(max-width: 959px) {
        .addressandmap__row {
            display: flex;
            flex: auto !important;
            flex-direction: column;
        }
        .addressandmap__row__col__map__row__col__map {
            height: 274px !important;
        }
    }
    /*WARINING-BOX-RESPONSIVE*/
        @media(max-width: 1114px) {
            .warningbox__row__col__type {
                height: 136px;
            }
        }
        @media(max-width: 600px) {
             .warningbox__row__col__type {
                height: 184px;
            }
        }
    /*END-WARNING-BOX-RESPONSIVE*/
/*###############################*/
::v-deep .v-skeleton-loader__text {
    margin-bottom: 0px !important;
    margin-top: 6px !important;
}
::v-deep .v-skeleton-loader__image {
    height: 100%;
}
</style>